var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsCashbackPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4644.000000, -1982.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Cashback-points",
    transform: "translate(4644.000000, 1982.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4,22 C14.5,22 15,22.5 15.1,23.6 L15.1,23.6 L15.1,30.4 C15.1,31.5 14.6,32 13.5,32 L13.5,32 L1.7,32 C0.6,32 0,31.5 0,30.4 L0,30.4 L0,23.6 C0,22.5 0.6,22 1.7,22 L1.7,22 Z M23,23 L27.1,27.1 C26.5,27.8 25.4,27.8 24.7,27.1 L24.7,27.1 L24,26.4 L24,28.3 C24,30.4 22.3,32 20.3,32 L20.3,32 L16.7,32 C16.9,31.5 17,31 17,30.4 L17,30.4 L17,30 L20.2,30 C21.2,30 21.9,29.2 21.9,28.3 L21.9,28.3 L21.9,26.4 L21.2,27.1 C20.6,27.8 19.5,27.8 18.8,27.1 L18.8,27.1 L23,23 Z M13,29 L2,29 L2,30 L13,30 L13,29 Z M6,24 L2,24 L2,27 L6,27 L6,24 Z M21,0 C27.1,0 32,4.9 32,11 C32,17.1 27.1,22 21,22 C14.9,22 10,17.1 10,11 C10,4.9 14.9,0 21,0 Z M8.1,10 C8,10.3 8,10.7 8,11 L8.0008,11.1904 C8.004,11.456 8.02,11.76 8.1,12 L8.1,12 L6.9,12 C5.9,12 5.2,12.8 5.2,13.7 L5.2,13.7 L5.2,15.6 L5.9,14.9 C6.6,14.2 7.6,14.2 8.4,14.9 L8.4,14.9 L4.2,19 L0,14.9 C0.6,14.2 1.7,14.2 2.4,14.9 L2.4,14.9 L3.1,15.6 L3.1,13.7 C3.1,11.6 4.8,10 6.8,10 L6.8,10 Z M21.4,5 C20.8,5 20.3,5.4 20.1,6 L20.1,6 L19.3,8.7 L15.6,8.7 C15.4,9.3 15.6,9.9 16.1,10.3 L16.1,10.3 L18.3,11.9 L17,15.8 C17.2,16 17.5,16.1 17.8,16.1 C18.1,16.1 18.4,16 18.6,15.8 L18.6,15.8 L20.8,13.8 L23.8,16 C24.3,15.7 24.5,15 24.3,14.4 L24.3,14.4 L23.5,11.8 L26.5,9.6 C26.3,9 25.8,8.6 25.2,8.6 L25.2,8.6 L22.5,8.6 Z",
    id: 337
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsCashbackPoints);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-cashback-points.09e265fc.svg";
export { ForwardRef as ReactComponent };